<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          'A duplicate ID happens when the same person is assigned two different identifiers',
        ],
      },
      {
        header: 'Search:',
        body: [
          "Searching by Session will provide results that will save even after the user leaves the page, as long as the user's session remains active. To save the search results for future use, search by Queue.",
        ],
      },
      {
        header: 'Field to Search:',
        body: [
          'Be sure to select at least one name field (i.e., Last Name, First Name) to generate quality results. This will be used to generate the list of potential duplicates.',
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
